import { useParams } from 'react-router-dom';
import AssessmentViewer from '../components/assessment/AssessmentViewer';
import { Col, Container, Row } from 'react-bootstrap';
import { useRecordPageView } from '../hooks/useRecordPageView';

const Assessment = () => {
  const { assessmentId } = useParams<{ assessmentId: string }>();

  useRecordPageView();

  if (!assessmentId) {
    return (
      <Container fluid className="d-flex vh-100">
        <Row className="justify-content-center align-self-center w-100">
          <Col className="text-center">
            <h3>Assessment not found.</h3>
            Please contact support.
          </Col>
        </Row>
      </Container>
    );
  }

  return <AssessmentViewer assessmentId={assessmentId} />;
};

export default Assessment;
